"use strict";
var sliderService = angular.module('sliderService', []);
sliderService.service('SliderService', function(){
    var sliders = [];
    var pushSlider = function(slider) {
        if (sliders.length === 0) {
            sliders.push(slider);
            sliders[0].sliderOverOpen = true;
        }
        else {
            var flag = null;
            for (var i = 0; i < sliders.length; i++) {
                if (sliders[i].size == slider.size) {                                   // if they're the same size
                    if (sliders[i].partial == slider.partial) {                         // if they're the same partial
                        if (sliders[i].paramObj !== slider.paramObj) {                  // if they're not passing the same params
                            sliders[i] = {};
                            slider.sliderOverOpen = true;
                            sliders[i] = slider;                                        // replace the params
                        }
                        else {                                                          // if they are passing the same params
                            closeSlider(i);                                                 // close the slider
                        }
                    }
                    else {                                                              // if they're not the same partial
                        slider.sliderOverOpen = true;
                        sliders[i] = slider;                                                // load in the new partial
                    }
                    flag = false;                                                       // you're not pushing a new slider
                }
                else {                                                                  // if they're not the same size
                    if (flag === false) {
                        if ((slider.size == 'm' && sliders[i].size=='s') || (slider.size == 'l' && (sliders[i].size=='s' || sliders[i].size=='m')))
                            closeSlider(i);
                    }
                    else {
                        flag = true;                                                        // set the flag as true, lets keep checking to see if we need to replace
                    }
                }
            }
            if (flag === true) {                                                         // if the flag is still true and we can push one
                sliders.push(slider);                                                       // push one
                sliders[sliders.length-1].sliderOverOpen = true;
            }        
        }
    };
    var closeSlider = function(index) {
        if (typeof index === 'undefined') {
            sliders = [];
        }
        else {
            if (sliders.length==1)
                index = 0;
            sliders[index].sliderOverOpen = false;
            for (var i = 0; i < sliders.length; i++) { // close smaller sliders
                if ((sliders[index].size == 'm' && sliders[i].size=='s') || (sliders[index].size == 'l' && (sliders[i].size=='s' || sliders[i].size=='m')))
                    closeSlider(i);
            }
            setTimeout(function() {                                                         //adding timeout to preserve css slide animation
                sliders.splice(index, 1);
            }, 1000);  
        }
    };
    var returnSliders = function() {
        return sliders;
    };
    var getHeader = function() {
        if (sliders.length>0)
            return sliders[0].header;
    };
    var getPartial = function() {
        if (sliders.length>0)
            return sliders[0].partial;
    }
    var printClick = function(title) {
        var mywindow = window.open('', '', 'height=400,width=800');
        mywindow.document.write('<html><head><title>' + title +'</title>');
        // mywindow.document.write('<link rel="stylesheet" type="text/css" href="stylesheets/css/style.css" />');
        mywindow.document.write('<link rel=\"stylesheet\" type=\"text/css\" href=\"production/css/source.css\" /></head><body>');
        mywindow.document.write($('#printslider').html());
        mywindow.document.write('</body></html>');
        mywindow.document.close(); // necessary for IE >= 10
        mywindow.focus(); // necessary for IE >= 10
        mywindow.onload = function() {
            this.print();
            this.close();
        };
        return true;
    }
    return {
            pushSlider: pushSlider, 
            closeSlider: closeSlider,
            returnSliders: returnSliders,
            getHeader: getHeader,
            getPartial: getPartial,
            printClick: printClick
        };
});

sliderService.factory('SliderFactory', function(){
    var SliderModel = function(partial, header, size, params) {
        this.partial = '';
        this.content = '';
        this.header = '';
        this.size = 's';
        this.paramObj = {}; //used for set partial
        this.sliderOverOpen = false;
        if (this.partial == partial && this.header == header && angular.equals(this.paramObj, params)) {
            this.header='';
            this.partial='';
            this.paramObj = params;
        }
        else {
            this.header = header;
            this.partial = partial;
            this.paramObj = params;
            if (size!==undefined) 
                this.size = size;
        }

    };

    //BUILT SPECIFICALLY FOR FAST 4.1
    SliderModel.printClick = function(title) {
        console.log("hey!");
        var mywindow = window.open('', '', 'height=400,width=800');
        mywindow.document.write('<html><head><title>' + title +'</title>');
        // mywindow.document.write('<link rel="stylesheet" type="text/css" href="stylesheets/css/style.css" />');
        mywindow.document.write('<link rel=\"stylesheet\" type=\"text/css\" href=\"production/css/source.css\" /></head><body>');
        mywindow.document.write($('#printslider').html());
        mywindow.document.write('</body></html>');
        mywindow.document.close(); // necessary for IE >= 10
        mywindow.focus(); // necessary for IE >= 10
        mywindow.onload = function() {
            this.print();
            this.close();
        };
        return true;
    };

    return SliderModel;
});